"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatAggregatedError = (aggregatedError, argusRequestId) => {
    let body = "";
    if (argusRequestId)
        body = `ARGUS-Id: ${argusRequestId}\n`;
    body = `${body}
    URL: ${aggregatedError.url}\n
    Environment: ${aggregatedError.environment}\n
    Timestamp: ${aggregatedError.timestamp}\n
    Error Stack: \n${aggregatedError.mappedErrorStack}\n
    `;
    return body;
};
exports.default = formatAggregatedError;
